var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(!_vm.value)?[_c('v-btn',{on:{"click":_vm.createRule}},[_vm._v("Add rule")])]:[_c('RuleWrapper',{attrs:{"value":_vm.value},on:{"input":function($event){return _vm.$emit('input', $event)}}})]],2)}
var staticRenderFns = []

export { render, staticRenderFns }